// extracted by mini-css-extract-plugin
export default {"container":"styles_container__3btqT","text":"styles_text__BW3ib","icon":"styles_icon__UBtMT"};